
      var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3.054,
  y: 6.719,
  width: 19.176,
  height: 13.564,
  rx: 1.714,
  fill: "var(--theme-bright, #e3d2e9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.759 5.28v13.44c0 .929.752 1.68 1.68 1.68h16.802a.84.84 0 0 0 .84-.84V7.8a.84.84 0 0 0-.84-.84H4.439a1.68 1.68 0 0 1-1.68-1.68v0c0-.929.752-1.68 1.68-1.68h14.282",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17.461,
  cy: 13.68,
  r: 1.26,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"3.05371\" y=\"6.7193\" width=\"19.1761\" height=\"13.5636\" rx=\"1.71429\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n<path d=\"M2.75903 5.2793V18.7207C2.75903 19.6486 3.51127 20.4009 4.43921 20.4009H21.241C21.7049 20.4009 22.0811 20.0248 22.0811 19.5608V7.79956C22.0811 7.33559 21.7049 6.95947 21.241 6.95947H4.43921C3.51127 6.95947 2.75903 6.20723 2.75903 5.2793V5.2793C2.75903 4.35136 3.51127 3.59912 4.43921 3.59912H18.7207\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"17.4606\" cy=\"13.6802\" r=\"1.26013\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wallet.3aefc7673e777302406b787e99e090dc.svg"),
        {
          React: SvgWallet,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      